/**
 * Event type of the point direction
 */
export enum EventType {

	/**
	 * Left point
	 */
	LEFT,

	/**
	 * Right point
	 */
	RIGHT

}
